<div><ngx-imageviewer [src]="src" [filetype]="filetype"></ngx-imageviewer></div>



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/core/file-viewer/file-viewer.component.html